"use client";

import { useEffect, useState } from "react";

import { DesktopIssueReporter } from "@/components/desktop/DesktopIssueReporter";
import { I18nProvider } from "@/components/i18n/I18nProvider";
import { isDesktopIssueReportingRuntime } from "@/lib/desktop/diagnostics";

export const DESKTOP_ISSUE_REPORT_EVENT = "findin-desktop:open-issue-report";

export function DesktopIssueReportBridge() {
  const [supported, setSupported] = useState(false);
  const [autoOpenKey, setAutoOpenKey] = useState<number | null>(null);

  useEffect(() => {
    const runtimeSupported = isDesktopIssueReportingRuntime();
    setSupported(runtimeSupported);
    if (!runtimeSupported) {
      return;
    }

    const handleIssueReport = (event: Event) => {
      event.preventDefault();
      setAutoOpenKey((current) => current === null ? 1 : current + 1);
    };

    window.addEventListener(DESKTOP_ISSUE_REPORT_EVENT, handleIssueReport);
    return () => {
      window.removeEventListener(DESKTOP_ISSUE_REPORT_EVENT, handleIssueReport);
    };
  }, []);

  if (!supported) {
    return null;
  }

  return (
    <I18nProvider>
      <DesktopIssueReporter autoOpenKey={autoOpenKey}>
        <button type="button" className="hidden" tabIndex={-1} aria-hidden="true" />
      </DesktopIssueReporter>
    </I18nProvider>
  );
}
